define(['text!./templates/ho-confirmation.html'],
    (templateStr)=> {
        return [function () {
            return {
                restrict: 'A',
                template: templateStr,
                controller: ['$scope', function ($scope) {
                    this._coverages = (coverages)=> {
                        return coverages.map((cov)=> {
                            return {name: cov.description, amount: cov.amount, terms: cov.terms};
                        });
                    };

                    $scope.baseCoverages = this._coverages($scope.chosenQuote.lobs.homeowners.baseCoverages);
                    $scope.additionalCoverages = this._coverages($scope.chosenQuote.lobs.homeowners.additionalCoverages);
                    $scope.scheduledProperties = $scope.chosenQuote.lobs.homeowners.scheduledProperties;
                    $scope.basePremium = $scope.chosenQuote.lobs.homeowners.basePremium;
                }]
            };
        }];
    }
);



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/ho/directives/HOConfirmation.js
 **/